export enum DataEntityType {
  Rental = 'rental',
  Guest = 'guest',
  Expense = 'expense',
  Extra = 'extras',
  Task = 'task',
  Inquiry = 'inquiry',
  User = 'user',
  HoldEvent = 'hold_event',
  Invoice = 'invoice',
  InvoiceTemplate = 'invoice_template',
  InvoiceRule = 'invoice_rule',
  CustomCode = 'custom_code',
  Incident = 'incident',
  Inventory = 'inventory',
}

export const dataEntityTypes = [
  { value: 'rental', label: $localize`Rental` },
  { value: 'guest', label: $localize`Guest` },
  { value: 'expense', label: $localize`Expense` },
  { value: 'extras', label: $localize`Extra` },
  { value: 'task', label: $localize`Task` },
  { value: 'inquiry', label: $localize`Inquiry` },
  { value: 'user', label: $localize`User` },
  { value: 'hold_event', label: $localize`Hold Event` },
  { value: 'invoice', label: $localize`Invoice` },
  { value: 'invoice_template', label: $localize`Invoice Template` },
  { value: 'invoice_rule', label: $localize`InvoiceRule` },
  { value: 'custom_code', label: $localize`CustomCode` },
  { value: 'incident', label: $localize`Incident` },
  { value: 'inventory', label: $localize`Inventory` },
]
